import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export const exportToExcel = async (rows, columnsToExtract, fileName, reportName) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Sheet1');

  // Extract headers and fields from columnsToExtract
  const headers = columnsToExtract.map(col => col.headerName);
  const fields = columnsToExtract.map(col => col.field);

  if (reportName) {
    // Add report name
    const reportRow = worksheet.addRow([reportName]);
    reportRow.font = { size: 16, bold: true };
    reportRow.alignment = { horizontal: 'center' };
    worksheet.mergeCells(1, 1, 1, columnsToExtract.length);

    // Add timestamp
    const dateTime = new Date().toLocaleString();
    const dateRow = worksheet.addRow([]);
    dateRow.getCell(columnsToExtract.length).value = dateTime;
    dateRow.getCell(columnsToExtract.length).alignment = { horizontal: 'right' };
    dateRow.getCell(columnsToExtract.length).font = { size: 10 };

    worksheet.addRow([]);
  }

  // Add headers
  const headerRow = worksheet.addRow(headers);

  // Header formatting
  headerRow.eachCell(cell => {
    cell.font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 12 };
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FF000000' },
    };
    cell.border = {
      top: { style: 'thin', color: { argb: 'FF000000' } },
      left: { style: 'thin', color: { argb: 'FF000000' } },
      bottom: { style: 'thin', color: { argb: 'FF000000' } },
      right: { style: 'thin', color: { argb: 'FF000000' } },
    };
    cell.alignment = { horizontal: 'center', vertical: 'middle' };
  });

  // Add data rows
  rows.forEach(row => {
    const newRow = worksheet.addRow(
      fields.map(field => {
        const value = row[field] ?? '';
        return typeof value === 'string' ? value.replace(/\n/g, '\r\n') : value;
      })
    );

    // Data row formatting
    newRow.eachCell((cell, colNumber) => {
      cell.border = {
        top: { style: 'thin', color: { argb: 'FF000000' } },
        left: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
        right: { style: 'thin', color: { argb: 'FF000000' } },
      };
      cell.alignment = {
        vertical: 'top',
        horizontal: 'left',
        wrapText: true
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF' },
      };
    });
  });

  // Set column widths based on header length
  worksheet.columns = columnsToExtract.map(col => ({
    header: col.headerName,
    key: col.field,
    width: Math.max(col.headerName.length + 5, 15) // Minimum width of 15
  }));

  // Auto-adjust row heights
  worksheet.eachRow((row, rowNumber) => {
    let maxLineCount = 1;
    row.eachCell(cell => {
      const lineCount = cell.value?.toString().split('\r\n').length || 1;
      if (lineCount > maxLineCount) maxLineCount = lineCount;
    });
    row.height = 20 * maxLineCount;
  });

  // Generate and save file
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  saveAs(blob, `${fileName}.xlsx`);
};